import { Skeleton } from "@/components/ui/skeleton";

export const CommentListSkeleton: React.FC = () => (
  <div className="space-y-6">
    {[1, 2, 3].map((i) => (
      <div key={i} className="flex gap-3">
        <Skeleton variant="muted" className="size-11 shrink-0 rounded-full" />
        <div className="flex-1 space-y-2">
          <Skeleton variant="muted" className="h-4 w-24" />
          <Skeleton variant="muted" className="h-4 w-full" />
          <Skeleton variant="muted" className="h-4 w-2/3" />
        </div>
      </div>
    ))}
  </div>
);
